export default "__VITE_ASSET__BIjhQRjK__"